module.exports = "data:application/octet-stream;base64,Ly8gcmVtb3ZlZCBieSBleHRyYWN0LXRleHQtd2VicGFjay1wbHVnaW4="


//////////////////
// WEBPACK FOOTER
// ./src/components/finance/expenses.less
// module id = 36
// module chunks = 0